import "./LetsConnect.module.css";
import Header from "@/reusable_sections/Header";
import InquiriesCommissions from "./sections/InquiriesCommissions";
import DoveTrovarci from "./sections/DoveTrovarci";
import Footer from "@/reusable_sections/Footer";
export default function LetsConnectPage() {
  return <div>
      <Header />
      <InquiriesCommissions />
      <DoveTrovarci />
      <Footer />
    </div>;
}